var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "cardsContainer" },
    [
      _vm._t("default", null, {
        getBlockMinHeight: _vm.getBlockMinHeight,
        setSize: _vm.setSize,
        elementsInRow: _vm.elementsInRow,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }